<template>
    <div id="report-chat-distributions">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <h2>{{ $t('report.chatCountsByUsers') }}</h2>
                    <ChatDistributionsByUser
                        :title="$t('report.chatCountsByUsers')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.byUser"
                    />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t('report.chatCountByPlatform') }}</h2>
                    <ChatDistributionsByPlatform
                        :title="$t('report.chatCountByPlatform')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.byPlatform"
                    />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t('report.chatCountsByAns') }}</h2>
                    <ChatDistributionsByAnswer
                        :title="$t('report.chatCountsByAns')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.byAnswer"
                    />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t('report.chatCountsByHandleType') }}</h2>
                    <ChatDistributionsByHandleType
                        :title="$t('report.chatCountsByHandleType')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.byHandleType"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import ChatDistributionsByUser from "./ChatDistributionsByUser.vue";
import { REPORT_API } from "../../../api/statistics";
import ChatDistributionsByPlatform from "./ChatDistributionsByPlatform.vue";
import ChatDistributionsByAnswer from "./ChatDistributionsByAnswer.vue";
import ChatDistributionsByHandleType from "./ChatDistributionsByHandleType.vue";

const log = log2("ChatDistributions");
export default {
    name: "ChatDistributions",
    components: {
        ChatDistributionsByHandleType,
        ChatDistributionsByAnswer,
        ChatDistributionsByPlatform,
        ChatDistributionsByUser,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                byUser: [],
                byAnswer: {},
                byHandleType: {},
                byPlatform: [],
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.chatDistributionsAll(this.filters)
                .then((res) => {
                    log("sessionOverall data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-chat-distributions {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                h2 {
                    text-align: center;
                    font-weight: 700;
                    font-size: 40px;
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
